// 导入 IMLib 5.X
import * as RongIMLib from "@rongcloud/imlib-next";
// // 导入 RTCLib
// import {installer as rtcInstaller, RCRTCClient, RCTrack, RCFrameRate, RCResolution} from "@rongcloud/plugin-rtc";
// 导入 CallLib
import {
    installer as callInstaller,
    RCCallClient,
    RCCallSession,
    RCCallErrorCode,
    IDeviceChangeParams,
    ISessionListener,
    IEndSummary,
    ISenderInfo,
    IMuteUser,
    IInvitedUsers,
    RCCallLanguage,
    RCCallEndReason,
    RCCallMediaType,
    IOfflineRecord,
    RCCallSessionState
} from "@rongcloud/plugin-call";
import request from "@/api/request.js"
import store from "../../store";

export default {
    caller: null,
    session:null,
    initIM: (videoType) => {
        // if (this.caller) {
        //     return
        // }
        let userId = store.state.userInfo.userId;
        if(!this.caller){
            RongIMLib.init({
                appkey: '8luwapkv8dxwl',
            });
            const rtcClient = RongIMLib.installPlugin(RCRTC.installer)
            this.caller = RongIMLib.installPlugin(RCCall.installer, {
                rtcClient,
                onSession(session) {
                    session.registerSessionListener({
                        onRinging(sender, session) {
                            const {userId} = sender;
                        },
                        onAccept(sender, session) {
                            const {userId} = sender;
                        },
                        onHungup(sender, reason, session) {
                            console.log(sender,reason, session)
                            request.removeEngagedLineToken({
                                userId:store.state.voiceUserId
                            }).then(res=>{
                                console.log(res)
                                window.location.reload()
                            })
                            store.commit('getEngagedLine',false)
                            this.initIM()
                            session.hungup()
                            const {userId} = sender;
                        },
                        onTrackReady(track, session) {
                            if (track.isAudioTrack() && !track.isLocalTrack()) {
                                track.play();
                            }
                            if (track.isVideoTrack()) {
                                const video = document.getElementById(
                                    "video"
                                );
                                track.play(video);
                            }
                        },
                        //当有用户静音
                        onAudioMuteChange: (muteUser, session) => {
                            console.log('对方静音了')
                        },
                        onMediaModify: (sender, mediaType, session) => {
                            console.log('对方转为了语音通话')
                        }
                    });
                },
                onSessionClose(session, summaryInfo) {
                    console.log(summaryInfo,'通话信息')
                    session.hungup()
                    store.commit('videoShow',false)
                },
            });
        }
        let token = ""
        // IM 客户端初始化
        request.getToken({userId}).then(res => {
            RongIMLib.connect(res.data.token).then(res => {
                if (res.code === 0) {
                    store.commit('getVideoUserId', res.data.userId)
                    // store.commit("callingUserId",res.data.userId)
                    // console.log('我存进数据了', res.data.userId)
                } else {
                    console.warn('链接失败, code:', res.code)
                }
            })

        })
    },
    call: (type) => {
        console.log('targetId', store.state.customer.adminId,type)
        const {code, session} = this.caller.call({
            targetId: store.state.customer.adminId,//对方的id
            mediaType: type,//类型
            listener: {
                onRinging: (sender, session) => {
                     const { userId } = sender;
                },
                onAccept: (sender, session) => {
                     const { userId } = sender;
                },
                onHungup: (sender, reason, session) => {
                    console.log(store.state.voiceUserId)
                    request.removeEngagedLineToken({
                        userId:store.state.voiceUserId
                    }).then(res=>{
                        window.location.reload()
                    })
                    window.location.reload()
                    store.commit('videoCallType',0)
                    const { userId } = sender;
                },
                 //当有用户静音
                 onAudioMuteChange: (muteUser, session) => {
                },
                onMediaModify: (sender, mediaType, session) => {
                    store.commit('videoCallType',1)
                },
                onTrackReady: (track, session) => {
                    // store.commit("callingUserId",track._userId)
                    track.isLocalTrack() //是否为本地资源
                    track.isAudioTrack() //是否为音频
                    track.isVideoTrack() //是否为视频
                    track.getUserId()    //产生该 track 的用户id
                    store.commit('videoShow',true)
                    this.session = session
                    if (track.isAudioTrack() && !track.isLocalTrack()) {
                        track.play();
                    }
                    if (track.isVideoTrack()) {
                        const video = document.getElementById(
                            "video"
                        );
                        track.play(video);
                    }
                },
                // onMemberModify: (sender, invitedUsers, session) => {
                //     console.log(sender, invitedUsers, session);
                // },
                // onMediaModify: (sender, mediaType, session) => {
                //     console.log(sender, mediaType, session)
                // },
                // onAudioMuteChange: (muteUser, session) => {
                //     console.log(muteUser, session);
                // },
                // onVideoMuteChange: (muteUser, session) => {
                //     console.log(muteUser, session);
                // },
            },
        });
        if (code === RCCallErrorCode.SUCCESS) {
            console.log('成功了')
        }
    },
    //挂断电话
    callHungup:()=>{
        console.log('走这了 163行')
        request.removeEngagedLineToken({
            userId:store.state.voiceUserId
        }).then(res=>{
            console.log(res)
            window.location.reload()
        })
        // console.log('我挂断了，155')
        store.commit('videoCallType',0)
        this.session.hungup()
        store.commit('getEngagedLine',false)
        store.commit('videoShow',false)//电话挂断对应功能按钮隐藏
    },
    //静音
    callDisableAudioTrack:()=>{
        this.session.disableAudioTrack()
    },
    //开启视频
    callEnableAudioTrack:()=>{
        this.session.enableAudioTrack()
    },
    //将视频转化为语音
    callDescendAbility:()=>{
        this.session.descendAbility()
    },
}






// WEBPACK FOOTER //
// ./src/components/rongVideo/index.js